import { type ModalName } from '@/modals-names';

import { useModal } from './hooks';
import { type ModalWrapperProps } from './types';

/**
 * Helper for creating hooks for using different modals
 */
export const makeUseModal = <Props extends ModalWrapperProps>(name: ModalName) => {
  return (props?: Props) => {
    return useModal<Props>(name, props);
  };
};
